import React, { Component } from "react";
import Sticky from "Components/Sticky";
import Dropdown from "Components/Dropdown";
import { CONTRACT_DATA, HEADERS } from "./constants";
import ResponsiveTable from 'Components/ResponsiveTable';
import Heading from 'Components/Heading';
import Cx from 'classnames';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { DateRangePicker } from 'react-dates';
import Moment from 'moment';
import { connect } from 'react-redux';
import { GET_EXISTING_CONTRACT_DETAILS, GET_YARD_TO_YRAD_CONSTANTS_LIST, CALUCALATE_FREIGHT_RATE, POST_GENERATE_CONTRACT_DETAILS, UPLOAD_MULTI_MODE_CONTRACTS, DOWNLOAD_MULTI_MODE_CONTRACTS } from 'Constants/actionConstants';
import { RFQ_TYPE_NAMES, ROAD_RAIL_COASTAL_LEGS, PROVIDER_TYPES } from 'Constants/commonConstants';
import { ReactComponent as CalcIcon } from 'Icons/accounting.svg';
import Upload from 'Components/Upload';
import ActionLoader from 'Components/ActionLoader/index';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';

const RFQ_TYPES = [
    { name: 'Single Mode', value: 1 },
    { name: 'Multi Modal', value: 6 }
]

const LEG_TYPE = [
    { name: 'Door To Yard', value: 1 },
    { name: 'Full Rake', value: 2 },
    { name: 'Port To Port', value: 3 },
    { name: 'Port To Door', value: 4 }
]

const LEG_NAME = [
    { name: 'Transportation', value: 1 },
    { name: 'Handling at Origin', value: 2 },
    { name: 'First mile Port Charges', value: 3 },
    { name: 'Insurance Charges', value: 4 },
    { name: 'Railway cost inculding Insurance and Port charges', value: 5 },
    { name: 'Handling at destination', value: 6 },
    { name: 'Last Mile', value: 7 }
]


const loadType = [
    {name: 'Wagon', value: 1 },
    {name: 'Train', value: 2 }
]

class MultiModeContracts extends Component {
    constructor() {
        super();
        ROAD_RAIL_COASTAL_LEGS.push({
            name: 'Yard To Yard (BCN)', 
            label: 'Yard To Yard (BCN)',
            value: 2
          });
        this.state = {
            search: '',
            selectedRFQ: [],
            onAdd: false,
            filters: {
            },
            bcnParams: {}
        }
    }

    componentDidMount() {
        this.getContractList();
        const { dispatch } = this.props;
        dispatch({
            type: GET_YARD_TO_YRAD_CONSTANTS_LIST
        })
    }

    getContractList = () => {
        const { dispatch } = this.props;
        const { filters } = this.state;
        dispatch({
            type: GET_EXISTING_CONTRACT_DETAILS,
            params: filters
        })
    }

    onSearch = (e) => {
        const { name, value } = e.target;
        const { filters } = this.state;
        filters[name] = value;
        this.setState({
            filters
        }, this.getContractList)
    }

    onSelectAll = (e) => {
        if(e.target.checked) {
            this.setState({
                selectedRFQ: (this.props.contractData || [])
            })
        } else {
            this.setState({
                selectedRFQ: []
            })
        }
    }

    onSelectRFQ = (data) => {
        const selectedRFQ =  JSON.parse(JSON.stringify(this.state.selectedRFQ));
        const pIndex = selectedRFQ.findIndex(val => (val.trip_id === data.trip_id) && (val.transporter_id === data.transporter_id));
        if(pIndex > -1) {
            selectedRFQ.splice(pIndex, 1);
        } else {
            selectedRFQ.push(data)
        }
        this.setState({
            selectedRFQ
        })
    }

    onAdd = () => {
        const { onAdd } = this.state;
        this.setState({
            onAdd: !onAdd
        })
    }

    onSelect = (option, name) => {
        const { filters } = this.state;
        filters[name] = (option || {}).value;
        this.setState({ filters }, this.getContractList)
    }

    onSelectBCNValues = (value, name) => {
        const { bcnParams } = this.state;
        bcnParams[name] = value;
        this.setState({ bcnParams })
    }

    getCommodityNames = (category) => {
        const { YardToYardConstants } = this.props;
        const getFilteredNames = (YardToYardConstants.commodity || []).find(val => val.name === category);
        return getFilteredNames && getFilteredNames.commodityNames || [];
    }

    calculateFreight = () => {
        const { bcnParams } = this.state;
        const params = {
            // from: bcnParams.from || "HALDIA DOCK COMPLEX AND GENERAL- HDCG",
            // to: bcnParams.to || "KHALILABAD- KLD",
            // wagonType: bcnParams.wagonType || "BCNA- BOGIES COVERED AIR% BRAKES",
            // tariffLines: bcnParams.tariffLines || "GA",
            // commodityCategory: bcnParams.commodityCategory || "SUGAR",
            // commodityName: bcnParams.commodityName || "RAW CANE SUGAR"
            from: "HALDIA DOCK COMPLEX AND GENERAL- HDCG",
            to: "KHALILABAD- KLD",
            wagonType: "BCNA- BOGIES COVERED AIR% BRAKES",
            tariffLines: "GA",
            commodityCategory:  "SUGAR",
            commodityName: "RAW CANE SUGAR"
        }
        this.props.dispatch({
            type: CALUCALATE_FREIGHT_RATE,
            params,
            onSuccess: (data) => {
                const { selectedRFQ } = this.state;
                const result = data || {};
                result.legName = 'Yard To Yard (BCN)'
                selectedRFQ.push(result);
                this.setState({ selectedRFQ, bcnParams: {} });
            }
        })
    }

    foisTable = (freightValue) => (
        <table cellpadding="0" cellspacing="0" className="col-1">
            <thead>
                <tr>
                    <th></th>
                    {freightValue.map(val => <th>{val['Charge Name']}</th>)}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>Wagon Load</th>
                    {freightValue.map(val => <td style={{ 'borderBottom': '1px solid grey'}}>{val['Wagon Load']}</td>)}
                </tr>
                <tr>
                    <th>Train Load</th>
                    {freightValue.map(val => <td style={{ 'borderBottom': '1px solid grey'}}>{val['Train Load']}</td>)}
                </tr>
            </tbody>
        </table>
    )

    generateContract = () => {
        const { dispatch } = this.props;
        const { selectedRFQ, contractName } = this.state;
        dispatch({
            type: POST_GENERATE_CONTRACT_DETAILS,
            data: {
                list: selectedRFQ,
                contract_rfq_name: contractName
            },
            onSuccess: () => {
                this.setState({ selectedRFQ: [], contractName: '', openPopup: false });
            }
        })
    }

    onChange = (file) => {
        const { dispatch } = this.props;
        dispatch({
            type: UPLOAD_MULTI_MODE_CONTRACTS,
            file,
            onSuccess: this.getContractList
        })
    }

    downloadLink = () => {
        const { dispatch } = this.props;
        dispatch({
            type: DOWNLOAD_MULTI_MODE_CONTRACTS,
            data: {
                type: 1
            },
            onSuccess: (data) => {
                const link = document.createElement('a');
                link.href = data.link;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        })
    }

    onCancelFilter = (name) => {
        const { filters } = this.state;
        filters[name] = '';
        this.setState({ filters }, this.getContractList)
    }

    render() {

        const { search, selectedRFQ, onAdd, filters, bcnParams } = this.state;
        const { contractData, YardToYardConstants, loading } = this.props;
        return(
            <Sticky>
                {loading && <ActionLoader fixed={true} />}
                <div className="mt-10 ml-10 mr-10">
                    {!onAdd && 
                    <div className="flex mm-contracts">
                        <div className="mr-10 pr">
                            <input placeholder={"Search RFQ No."}
                            type="text" 
                            className="br-20 ht-40 bg-gray search"
                            value={filters.search}
                            name="search"
                            onChange={this.onSearch}
                            />
                            {filters.search && (filters.search || '').length > 0 && 
                            <span 
                                className="clearable__clear" 
                                onClick={() => this.onCancelFilter('search')}
                            >&times;</span>}
                        </div>
                        <div className="mr-10 flex border-theme br-5 fBold">
                            <span className="pr">
                                <input placeholder={"Source"}
                                type="text" 
                                className="br-5 ht-40 fs-14 fBold tCenter"
                                value={filters.source}
                                name="source"
                                onChange={this.onSearch}
                                />
                                {(filters.source || '').length > 0 && 
                                <span 
                                    className="clearable__clear" 
                                    onClick={() => this.onCancelFilter('source')}
                                >&times;</span>}
                            </span>
                            <span className="mt-10">{"-"}</span>
                            <span className="pr">
                                <input placeholder={"Destination"}
                                type="text" 
                                className="br-5 ht-40 fBold fs-14 tCenter"
                                value={filters.destination}
                                name="destination"
                                onChange={this.onSearch}
                                />
                                {(filters.destination || '').length > 0 && 
                                <span 
                                    className="clearable__clear" 
                                    onClick={() => this.onCancelFilter('destination')}
                                >&times;</span>}
                            </span>
                        </div>
                        <Dropdown 
                            items={RFQ_TYPES}
                            label="Select RFQ Type"
                            className="wt-200 mr-10"
                            displayKey="name"
                            selectedItem={RFQ_TYPES.find(rfqType =>{return rfqType.value === filters.rfqType})}  
                            name="rfqType"  
                            onSelect={this.onSelect}
                            canClear={true}
                        />
                        <Dropdown 
                            items={ROAD_RAIL_COASTAL_LEGS}
                            label="Select Leg Type"
                            className="wt-200 mr-10"
                            displayKey="name"
                            selectedItem={ROAD_RAIL_COASTAL_LEGS.find(legType =>{return legType.value === filters.legType})}  
                            name="legType"  
                            onSelect={this.onSelect}
                            canClear={true}
                        />
                        <Dropdown 
                            items={PROVIDER_TYPES}
                            label="Select Provider Type"
                            className="wt-200 mr-10"
                            displayKey="name"
                            selectedItem={PROVIDER_TYPES.find(pType =>{return pType.value === filters.legName})}  
                            name="legName"  
                            onSelect={this.onSelect}
                            canClear={true}
                        />
                        <DateRangePicker
                            startDate={filters.contractTenureFrom ? Moment(filters.contractTenureFrom) : null}
                            startDateId="startDate"
                            endDate={filters.contractTenureTo ? Moment(filters.contractTenureTo) : null}
                            endDateId="endDate"
                            onDatesChange={({ startDate, endDate }) => {
                                const { filters } = this.state;
                                filters.contractTenureFrom = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : undefined;
                                filters.contractTenureTo = endDate ? new Date(endDate).setHours(0, 0, 0, 0) : undefined;
                                this.setState({ filters }, () => {
                                    if((filters.contractTenureFrom && filters.contractTenureTo) || !(filters.contractTenureFrom && filters.contractTenureTo)) {
                                        this.getContractList()
                                    }
                                });
                            }}
                            focusedInput={this.state[`focusedInput`]}
                            onFocusChange={focusedInput => this.setState({ [`focusedInput`]: true ? focusedInput : null })}
                            displayFormat={'DD MMM YYYY'}
                            noBorder={true}
                            isOutsideRange={() => false}
                            minimumNights={0}
                            showClearDates={true}
                        />
                    </div>}

                    {/* {onAdd && 
                    <div>
                        <div className="theme-color fBold col-2 inBlock">
                            <BackIcon className="mr-10 fill-theme curP" onClick={this.onAdd}/>
                            {'Back'}
                        </div>
                        <Heading text="New Contract" className="col-2 inBlock"></Heading>
                    </div>} */}
                    {filters.legType === 2 && <div className="flex mt-5">
                            <div className="wt-250 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">From</div>
                                <Dropdown 
                                    items={YardToYardConstants.locations || []}
                                    selectedItem={(YardToYardConstants.locations || []).find(val => bcnParams.from === val.value )}
                                    name="from"
                                    onSelect={(e) => this.onSelectBCNValues(e.name, 'from')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="Select"
                                    searchEnabled={true}
                                />
                            </div>
                            <div className="wt-250 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">To</div>
                                <Dropdown 
                                    items={YardToYardConstants.locations || []}
                                    selectedItem={(YardToYardConstants.locations || []).find(val => bcnParams.to === val.value )}
                                    name="from"
                                    onSelect={(e) => this.onSelectBCNValues(e.name, 'to')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="Select"
                                    searchEnabled={true}
                                />
                            </div>
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Commodity Category</div>
                                <Dropdown
                                    items={YardToYardConstants.commodity || []}
                                    selectedItem={(YardToYardConstants.commodity || []).find(cc => { return bcnParams.commodityCategory === cc.name })}
                                    name="commodityCategory"
                                    onSelect={(el) => this.onSelectBCNValues(el.value, 'commodityCategory')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                />
                            </div>
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Commodity Name</div>
                                <Dropdown
                                    items={bcnParams.commodityCategory && this.getCommodityNames(bcnParams.commodityCategory) || []}
                                    selectedItem={(this.getCommodityNames(bcnParams.commodityCategory) || []).find(cc => { return bcnParams.commodityName === cc.name })}
                                    name="commodityName"
                                    onSelect={(el) => this.onSelectBCNValues(el.value, 'commodityName')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                />
                            </div>

                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Tarrif Lines</div>
                                <Dropdown
                                    items={YardToYardConstants.tariffLines || []}
                                    selectedItem={(YardToYardConstants.tariffLines || []).find(tt => { return bcnParams.tarrifLines === tt.value })}
                                    name="tarrifLines"
                                    onSelect={(el) => this.onSelectBCNValues(el.value, 'tarrifLines')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                />
                            </div>

                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Load Type</div>
                                <Dropdown
                                    items={loadType}
                                    selectedItem={loadType.find(tt => { return bcnParams.loadType === tt.value })}
                                    name="loadType"
                                    onSelect={(el) => this.onSelectBCNValues(el.value, 'loadType')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                />
                            </div>
                            
                            <div className="wt-150 mr-10">
                                <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Wagon Type</div>
                                <Dropdown
                                    items={YardToYardConstants.wagonType || []}
                                    selectedItem={(YardToYardConstants.wagonType || []).find(wt => { return bcnParams.wagonType === wt.value })}
                                    name="wagonType"
                                    onSelect={(el) => this.onSelectBCNValues(el.value, 'wagonType')}
                                    displayKey="name"
                                    className="flex-1 fs-14"
                                    label="---Select---"
                                />
                            </div>
                            <CalcIcon className="wt-30 ht-30 mt-25 curP" onClick={this.calculateFreight}/>
                        </div>}

                    <ResponsiveTable className="courier-table pv-10 ph-10 ">
                        {!onAdd &&
                        <table cellpadding="0" cellspacing="0" className="col-1">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            className="pt-10 pb-10"
                                            onChange={this.onSelectAll}
                                            checked={contractData.length === selectedRFQ.length}
                                        />
                                    </th>
                                    {HEADERS.map(val => <th>{val}</th>)}
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="table-data">
                                {contractData.map((data, index) => {
                                    return(
                                        <tr>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>
                                                <input
                                                    type="checkbox"
                                                    className="pt-10 pb-10"
                                                    checked={selectedRFQ.find(val => ((val.trip_id === data.trip_id) && (val.transporter_id === data.transporter_id))) ? true : false}
                                                    onChange={() => this.onSelectRFQ(data)}
                                                />
                                            </td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_type && RFQ_TYPE_NAMES[data.rfq_type] || ''}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.legName}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.provider_name}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.contract_tenure_from && Moment(data.contract_tenure_from).format('Do MMM, YYYY') || ''}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.contract_tenure_to && Moment(data.contract_tenure_to).format('Do MMM, YYYY') || ''}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.from}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.to}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.multi_mode_movement_type}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{(data.rfq_type !== 6 || data.provider_name === 'Transporter') ? (data.vehicle_details || {}).vehicle_type_name : ''}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{(data.rfq_type !== 6 || data.provider_name === 'Transporter') ? (data.vehicle_details || {}).vehicle_body_type_name || data.container_type || (data.container_details || {}).container_type : ''}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.number_of_vehicle}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.pricing_basis_name}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{(data.tat || {}).value} {(data.tat || {}).name}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.qbr}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.budget}</td>
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp1}</td> */}
                                            <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                                                <div>{data.transporter_name}</div>
                                                <div>{`${data.price} (${data.order_text})`}</div>
                                            </td>
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp1ContractStartDate}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp1ContractEndDate}</td> */}
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp2}</td> */}
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp2ContractStartDate}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp2ContractEndDate}</td> */}
                                            <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                                                <button className="ht-30 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25">
                                                    Extend
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>

                        </table>}
                        
                        {selectedRFQ.length > 0 && <div className="mb-50">
                        <Heading text="New Contract" className="col-2 inBlock pv-20"></Heading>
                        <table cellpadding="0" cellspacing="0" className="col-1 mt-10">
                            <thead>
                                <tr>
                                    {HEADERS.map(val => <th>{val}</th>)}
                                </tr>
                            </thead>
                            <tbody className="table-data">
                                {selectedRFQ.map((data, index) => {
                                    return(
                                        <>
                                        <tr>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number ? (data.rfq_type && RFQ_TYPE_NAMES[data.rfq_type] || '') : RFQ_TYPE_NAMES[6]}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number ? data.legName : 'Yard To Yard (BCN)'}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.provider_name}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.contract_tenure_from && Moment(data.contract_tenure_from).format('Do MMM, YYYY') || ''}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.contract_tenure_to && Moment(data.contract_tenure_to).format('Do MMM, YYYY') || ''}</td>
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.containerType}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.containerBody}</td> */}
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number ? data.from : data.from_station}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number ? data.to : data.to_station}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number ? <span>{(data.tat || {}).value} {(data.tat || {}).name}</span> : <span>{`Distance: ${data.fois_data.distance}`}</span>}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.rfq_number ? data.qbr : 
                                            <>
                                            <span><span>{'Wagon Load: '}</span>{((data.fois_data || {}).freight_table || []).find(val => val['Charge Name'] === 'Total Freight  (Rs.):')['Wagon Load']}</span><br/>
                                            <span><span>{'Train Load: '}</span>{((data.fois_data || {}).freight_table || []).find(val => val['Charge Name'] === 'Total Freight  (Rs.):')['Train Load']}</span>
                                            </>
                                            }</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.budget}</td>
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp1}</td> */}
                                            <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                                                {(data.legName === 'Yard To Yard (BCN)') ? 
                                                <div></div>
                                                : <>
                                                <div>{data.transporter_name}</div>
                                                <div>{`${data.price} (${data.order_text})`}</div>
                                                </>}
                                            </td>
                                            {/* <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp2ContractStartDate}</td>
                                            <td style={{ 'borderBottom': '1px solid grey'}}>{data.cp2ContractEndDate}</td> */}
                                        </tr>
                                        {((data.fois_data || {}).freight_table || []).length > 0 && <tr>
                                            <td colSpan={HEADERS.length + 1} style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                                            {this.foisTable((data.fois_data || {}).freight_table || [])}
                                            </td>
                                        </tr>}
                                        </>
                                    )
                                })}
                            </tbody>

                        </table>
                        </div>}
                    </ResponsiveTable>
                    
                </div>

                <div className="z-100 box-shadow pl-40 pv-10 pf b-0 col-1 bg-white">
                        {/* {!onAdd && <button className={Cx("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25 fRight", {
                            'disabled': selectedRFQ.length === 0
                        })}
                            onClick={this.onAdd}
                        >
                            Add
                        </button>} */}
                        
                        <div className="fRight">
                            <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25" onClick={this.downloadLink}>
                            Download
                            </button>
                            <Upload onChange={this.onChange}>
                              <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25" >Upload</button>
                           </Upload>
                            {selectedRFQ.length > 0 && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25"
                            onClick={() => this.setState({ openPopup: true })}>
                            Generate Contract
                            </button>}
                        </div>
                </div>
                {this.state.openPopup && <Overlay>
                    <div className="bg-white box-shadow ph-20 pv-20 br-5">
                        {/* <div className="mb-10 tCenter header-medium-color fSemibold fs-18">
                            }
                        </div> */}
                        <Input 
                            placeholder="Enter Contract Name" 
                            onChange={(e) => this.setState({ contractName: e.target.value})}
                            value={this.state.contractName} 
                            name="contractName" 
                            className="fs-14 no-border"
                            noTransition={true}
                            containerClassName="no-transition-container"
                        />
                        <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                            <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() => this.setState({ openPopup: false })}>Cancel</button>
                            <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" onClick={this.generateContract}>Save</button>
                        </div>
                    </div>    
                </Overlay>} 
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting, constants }) => {
    return {
       dataSubmitting: contracting.existingContracts.dataSubmitting,
       contractData: contracting.existingContracts.data || [],
       YardToYardConstants: constants.YardToYardConstants || {},
       loading: contracting.loader
    }
 };

export default connect(mapStateToProps)(MultiModeContracts);
